import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import AppActions from '../App/actions';
import {deleto, get, post, puto} from 'bukku/shared/ApiService';
import {t} from "@lingui/macro";
import {initRequest} from "./initInstruction/saga";
import { onTransactionTypeChangeListener } from './initInstruction/helpers/onTransactionTypeChange';

// Create instruction
export function* createInstructionRequest() {
    yield takeEvery(actions.CREATE_INSTRUCTION_REQUEST, function* ({ request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(post, '/instructions', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.CREATE_INSTRUCTION_SUCCESS,
                instruction: data.instruction,
            });
        }
        catch (error) {
            yield put({
                type: actions.CREATE_INSTRUCTION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* createInstructionSuccess() {
    yield takeEvery(actions.CREATE_INSTRUCTION_SUCCESS, function* () {
        yield message.success(t`The recurring instruction is created.`);
    });
}
export function* createInstructionError() {
    yield takeEvery(actions.CREATE_INSTRUCTION_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read instructions
export function* readInstructionsRequest() {
    yield takeEvery(actions.READ_INSTRUCTIONS_REQUEST, function* ({ request }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, '/instructions', request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_INSTRUCTIONS_SUCCESS,
                instructions: data.instructions,
                pagination: data.paging,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_INSTRUCTIONS_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readInstructionsSuccess() {
    yield takeEvery(actions.READ_INSTRUCTIONS_SUCCESS, () => {});
}
export function* readInstructionsError() {
    yield takeEvery(actions.READ_INSTRUCTIONS_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read instruction
export function* readInstructionRequest() {
    yield takeEvery(actions.READ_INSTRUCTION_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PULLING });
            const response = yield call(get, `/instructions/${id}`, null, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.READ_INSTRUCTION_SUCCESS,
                instruction: data.instruction,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_INSTRUCTION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PULLING });
        }
    });
}
export function* readInstructionSuccess() {
    yield takeEvery(actions.READ_INSTRUCTION_SUCCESS, () => {});
}
export function* readInstructionError() {
    yield takeEvery('READ_INSTRUCTION_ERROR', function* ({ error }) {
        yield message.error(error.message);
    });
}

// Update instruction
export function* updateInstructionRequest() {
    yield takeEvery(actions.UPDATE_INSTRUCTION_REQUEST, function* ({ id, request }, context) {
        try {
            context.allow_intercept = true;
            yield put({ type: AppActions.APP_START_PUSHING });
            const response = yield call(puto, `/instructions/${id}`, request, context);
            const data = yield response.data;

            // OK
            yield put({
                type: actions.UPDATE_INSTRUCTION_SUCCESS,
                instruction: data.instruction,
            });
        }
        catch (error) {
            yield put({
                type: actions.UPDATE_INSTRUCTION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* updateInstructionSuccess() {
    yield takeEvery(actions.UPDATE_INSTRUCTION_SUCCESS, function* () {
        yield message.success(t`The recurring instruction is updated.`);
    });
}
export function* updateInstructionError() {
    yield takeEvery(actions.UPDATE_INSTRUCTION_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Delete instruction
export function* deleteInstructionRequest() {
    yield takeEvery(actions.DELETE_INSTRUCTION_REQUEST, function* ({ id }, context) {
        try {
            yield put({ type: AppActions.APP_START_PUSHING });
            yield call(deleto, `/instructions/${id}`, null, context);

            yield put({
                type: actions.DELETE_INSTRUCTION_SUCCESS,
            });
        }
        catch (error) {
            yield put({
                type: actions.DELETE_INSTRUCTION_ERROR,
                error,
            });
        }
        finally {
            yield put({ type: AppActions.APP_STOP_PUSHING });
        }
    });
}
export function* deleteInstructionSuccess() {
    yield takeEvery(actions.DELETE_INSTRUCTION_SUCCESS, function* () {
        yield message.success(t`The recurring instruction is deleted.`);
    });
}
export function* deleteInstructionError() {
    yield takeEvery(actions.DELETE_INSTRUCTION_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

// Read next transaction date
export function* readNextTransactionDateRequest() {
    yield takeEvery(actions.READ_NEXT_TRANSACTION_DATE_REQUEST, function* ({ request }, context) {
        try {
            const response = yield call(get, `/instructions/next_date`, request, context);
            const data = yield response.data;

            yield put({
                type: actions.READ_NEXT_TRANSACTION_DATE_SUCCESS,
                nextTransactionDate: data.next_date,
            });
        }
        catch (error) {
            yield put({
                type: actions.READ_NEXT_TRANSACTION_DATE_ERROR,
                error,
            });
        }
    });
}
export function* readNextTransactionDateSuccess() {
    yield takeEvery(actions.READ_NEXT_TRANSACTION_DATE_SUCCESS, () => {});
}
export function* readNextTransactionDateError() {
    yield takeEvery(actions.READ_NEXT_TRANSACTION_DATE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(createInstructionRequest),
        fork(createInstructionSuccess),
        fork(createInstructionError),
        fork(initRequest),
        fork(readInstructionsRequest),
        fork(readInstructionsSuccess),
        fork(readInstructionsError),
        fork(readInstructionRequest),
        fork(readInstructionSuccess),
        fork(readInstructionError),
        fork(updateInstructionRequest),
        fork(updateInstructionSuccess),
        fork(updateInstructionError),
        fork(deleteInstructionRequest),
        fork(deleteInstructionSuccess),
        fork(deleteInstructionError),
        fork(readNextTransactionDateRequest),
        fork(readNextTransactionDateSuccess),
        fork(readNextTransactionDateError),
        fork(onTransactionTypeChangeListener),
    ]);
}
